import { render } from "./modal-window.vue?vue&type=template&id=9a4c1ac0&scoped=true&ts=true"
import script from "./modal-window.vue?vue&type=script&lang=ts"
export * from "./modal-window.vue?vue&type=script&lang=ts"

import "./modal-window.vue?vue&type=style&index=0&id=9a4c1ac0&lang=scss&scoped=true"

import exportComponent from "/Users/gkozyrev/Desktop/Projects/Ginoice/Projects/Dmitry_Voloshin-dornn/cybercola/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a4c1ac0"]])

export default __exports__